import { Stack, Icon, Typography } from '@mui/material'

import Styles from './style.js'

import NodataSvg from '../../media/search.svg'

export const Nodata = (props) => {
    const rootSx = {
        ...Styles.root,
        ...(props.sx || {})
    }

    return (
        <Stack justifyContent={'center'} alignItems={'center'} direction={'column'} sx={rootSx}>
            {!props.noIcon && (<Icon sx={Styles.icon}>{props.icon || 'insights'}</Icon>)}
            {props.img && (<img style={Styles.img} src={NodataSvg} alt={'Nodata'} />)}
            {props.label && (<Typography variant={'h4'} sx={Styles.label}>{props.label || 'No data available'}</Typography>)}
        </Stack>
    )
}

export default Nodata